import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from 'src/components/Spinner';
import macheteDux from 'src/redux/machete';
import appDux from 'src/redux/app/';
import DesignPro from 'src/components/DesignPro/DesignPro';
import ErrorModal from 'src/components/ErrorModal/ErrorModal';
import constants from 'src/constants';
import trackError from 'src/lib/rollbar';
import { LayoutContainer } from './DesignProStyled';

/*
 * This is a legacy stylesheet from website.
 * Eventually we should delete it and replace with styles in styled components.
 */
import 'src/assets/styles/account-legacy.css';

const { TRIGGER_ERROR_ON_LOAD } = constants.devFlags;
const { types: errorModalTypes } = constants.errorModals;
const { TEST_ERROR } = constants.errors;

const mapStateToProps = (state) => ({
  isInitialized: state.designPro.app.initialized,
  shouldShowSpinner: appDux.selectors.shouldShowDesignProSpinner(state),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      activateErrorModal: appDux.actions.activateErrorModal,
      designProInit: macheteDux.actions.init,
    },
    dispatch,
  );

export class DesignProLayout extends PureComponent {
  static propTypes = {
    activateErrorModal: PropTypes.func.isRequired,
    designProInit: PropTypes.func.isRequired,
    shouldShowSpinner: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { jobId, modelId } = this.props.match.params;

    this.props.designProInit(jobId, modelId, this.props.location.search);
    this.triggerErrorOnLoad();
  }

  /*
   * This method is used strictly for testing purposes.
   * Only set the flag to true in localstorage if you want to trigger an error.
   */
  triggerErrorOnLoad() {
    const { activateErrorModal } = this.props;
    // Not placing flag in split because it's too risky
    if (localStorage.getItem(TRIGGER_ERROR_ON_LOAD) === 'true') {
      try {
        throw new Error(TEST_ERROR);
      } catch (e) {
        activateErrorModal(errorModalTypes.DEFAULT);
        trackError(TEST_ERROR, e);
      }
    }
  }

  render() {
    const { shouldShowSpinner } = this.props;

    return (
      <LayoutContainer>
        <DesignPro />
        {shouldShowSpinner && <Spinner />}
        <ErrorModal />
      </LayoutContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesignProLayout);
